import { useMe } from 'data/hooks/useMe';

export const useTutorial = () => {
  const { me } = useMe();
  const showTutorial = !(me && me.installationTimestamp);
  return showTutorial;
};
